<!--校园安全管理-->
<template>
    <div class="app-container">
        <el-card v-has-btn="'1,2,'" class="mb15">
            <el-row>
                <el-col :span="16" class="mb0">
                    <el-button v-has-btn="'1,2'" @click="handleCreate" type="primary">新增校园安全</el-button>
                </el-col>
            </el-row>
        </el-card>

        <el-card>
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="90px"
                     @submit.native.prevent="handleQuery">
                <el-row class="mt15">
                    <el-col :span="6" class="mb0">
                        <el-form-item label="政策类别">
                            <el-select clearable @change="pageList(null)" v-model="queryParams.category" placeholder="请选择">
                                <el-option v-for="item in categoryList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10" class="mb0"></el-col>
                    <el-col :span="8" class="mr0 mb0">
                        <el-form-item class="pull-right">
                            <el-input v-model="queryParams.title" placeholder="请输入标题" class="input-with-select">
                                <template #append>
                                    <el-button @click="handleQuery" type="primary" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="bre9e mt15">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          :height="`calc(100vh - 330px)`"
                          v-loading="loading" :data="dataList" highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column width="400" label="标题" align="center" prop="title">
                        <template #default="scope">
                            <div :title="scope.row.title" @click="handleView(scope.row)" style="color: #409efe;"
                                 class="text-one cursor">
                                {{ scope.row.title }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="240" label="所属类别" align="center" prop="categoryName">
                        <template #default="scope">
                            <div :title="scope.row.categoryName"
                                 class="text-one cursor">
                                {{ scope.row.categoryName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" label="是否置顶" align="center" prop="isTop">
                        <template #default="scope">
                            <div v-if="scope.row.isTop === 1">是</div>
                            <div v-if="scope.row.isTop === 0">否</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="150" label="创建时间" prop="createTime">
                        <template #default="scope">
                            <div>{{ timestampDate(scope.row.createTime) }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" width="100" align="center" label="操作"
                                     class-name="small-padding fixed-width">
                        <template #default="scope">
                            <el-popover placement="bottom" trigger="click" :width="80" popper-style="padding: 5px 0 0">
                                <template #reference>
                                    <el-button>操作</el-button>
                                </template>
                                <template #default>
                                    <div>
                                        <div class="text-item" v-if="scope.row.isTop === 0">
                                            <el-text type="primary" @click="handleTop(scope.row)">置顶</el-text>
                                        </div>
                                        <div class="text-item" v-if="scope.row.isTop === 1">
                                            <el-text type="primary" @click="handleTop(scope.row)">取消置顶</el-text>
                                        </div>
                                        <div class="text-item">
                                            <el-text type="primary" @click="handleUpdate(scope.row)">编辑</el-text>
                                        </div>
                                        <div class="text-item">
                                            <el-popconfirm
                                              confirm-button-text="是"
                                              cancel-button-text="否"
                                              :icon="InfoFilled"
                                              icon-color="#626AEF"
                                              title="确定删除?"
                                              @confirm="handleDelete(scope.row)">
                                                <template #reference>
                                                    <el-text type="danger">删除</el-text>
                                                </template>
                                            </el-popconfirm>
                                        </div>

                                    </div>
                                </template>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="zdyfy">
                <pagination class="zdyfy" :background="false" :pageSizes="[10, 20, 30]" :total="total"
                            :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="pageList" />
            </div>
        </el-card>


    </div>
</template>
<script>
import { queryDict } from "@/api/admin/public";
import {pageZhengc,deleteZhengc,topZhengc} from "@/api/admin/zhengc"
import {timestampDate} from "@/utils/date";
export default {
    name: "schoolSafeIndex",
    components: {},
    data() {
        return {
            timestampDate,
            loading: false,
            categoryList:[],
            dataList:[],
            total:0,
            queryParams:{
                zhengcType:2,
                category:'',
                title:'',
                pageNum: 1,
                pageSize: 10,
            }
        };
    },
    created() {
        this.getQueryDict();
        this.pageList();
    },
    activated() {},
    watch: {},
    methods: {
        getQueryDict() {
            queryDict({ code: 'school_safe_category' }).then(res => {
                this.categoryList = res.data.data;
            })
        },
        handleCreate(){
            this.$router.push({
                path: "/schoolSafeCreate",
            });
        },
        handleUpdate(row){
            this.$router.push({
                path: "/schoolSafeCreate",
                query: {
                    zhengcId: row.zhengcId,
                }
            });
        },
        handleTop(row){
            topZhengc({ zhengcId: row.zhengcId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.pageList(null);
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        handleDelete(row){
            deleteZhengc({ zhengcId: row.zhengcId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.pageList(null);
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        handleQuery(){
            this.pageList(null);
        },
        pageList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageZhengc(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading = false;
                }
            })
        },
        handleView(row){
            this.$router.push({
                path: "/schoolSafeDetail",
                query: {
                    zhengcId: row.zhengcId,
                }
            });
        }
    }
}
</script>

<style scoped>
/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}
</style>
